<div class="row form-group">
  <label class="control-label col-4">{{'Lý do' | translate}}<span class="cred">(*)</span></label>
  <div class="col-8 required-field">
    <textarea type="text" tabindex="1" class="form-control" rows="3" [(ngModel)]="doituongSelect.LyDo"></textarea>
  </div>
</div>

<div class="form-group row">
  <label class="control-label col-4">{{'Ngày nhập' | translate}}<span class="cred">(*)</span></label>
  <div class="col-8">
    <kendo-dateinput tabindex="2" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayNhap"></kendo-dateinput>
  </div>
</div>


<div class="form-group row">
  <label class="control-label col-4">{{'Trạng thái' | translate}}<span class="cred">(*)</span></label>
  <div class="col-8">
    <ng-select #slTrangThai
               class="twcollong"
               [tabIndex]="3"
               [openOnEnter]="false"
               [items]="dstrangthais"
               bindValue="Id"
               bindLabel="Ten"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               [(ngModel)]="doituongSelect.TrangThai">
      <ng-template ng-option-tmp let-item="item">

        <div class="rTableRow">
          <div class="rTableCell">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>


<div class="row form-group">
  <label class="control-label col-4">{{'Ghi chú' | translate}}</label>
  <div class="col-8 required-field">
    <textarea type="text" tabindex="4" class="form-control" rows="3" [(ngModel)]="doituongSelect.GhiChu"></textarea>
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-4 ng-binding">Người tạo</label>
  <div class="col-8">
    <input type="text" tabIndex="6" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
  </div>
</div>



<div class="row form-group">

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox"> password
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> Đã xử lý xong
      </label>
    </div>-->
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button type="submit" (click)="ThucHien()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>

</div>


